import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import _ from 'lodash'
import { SelectDD , ExternalDD } from '../../../../common/dropdowns';
import DateInput from '../../../../common/DateInput'
import DatePicker from "react-datepicker";
import TabSwitch from '../../../../common/TabSwitch'
import Actions from '../../../../appFlux/action'
import { scoreType, divisionTypes } from '../../../../appConstants'

class EditMyExpModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, qualifications } = props
        this.state = {
            qualifications: _.cloneDeep(qualifications),
            index: qualifications.length > 0 ? 0 : undefined,
            inputDegree: "",
        }
    }

    componentWillRecieveProps(props){
        var { modal, toggle, qualifications } = props
        console.log("I AM TRIGGERED.....................")
        this.setState({
            qualifications: _.cloneDeep(qualifications),
            index: qualifications.length > 0 ? 0 : undefined,
            inputDegree: "",
        })
    }

    setIndex = (index) => {
        this.setState({ index })
    }

    setQualifications = (value, param) => {
        var { qualifications, index } = this.state
        qualifications[index][param] = value
        this.setState({qualifications})
    }

    addQualification = () => {
        var { qualifications, inputDegree, index } = this.state
        var newQualification = {
            degree: inputDegree,
            field: "",
            institute: "",
            city: "",
            country: "",
            instituteLink: "",
            startDate: "",
            endDate: "",
            description: "",
            scoreType:  'percentage',
            score:  "",
            total: "",
            divisionType: 4
        }
        qualifications.push(newQualification)
        index = qualifications.length - 1
        this.setState({qualifications, index})
    }

    changeCurrentPosition = (value) => {
        var {index, qualifications } = this.state
        if(value === false){
            qualifications[index]["active"] = false
            this.setState({qualifications})
            return
        }
        // Handle True
        var exists = false
        qualifications.forEach((o, i) => {
            if(i !== index && o.active === true) exists = true
        })
        if(exists){
            if(window.confirm('You have another current position, would you like to end it ?')){
                qualifications.forEach((o, i) => o.active = false)
                qualifications[index]["active"] = true
                this.setState({qualifications})
            }
            else return 
        }
        else {
            qualifications[index]["active"] = true
            this.setState({qualifications})
        }
    }

    onScoreTypeChange = (obj) => {
        var { qualifications, index } = this.state
        qualifications[index]['scoreType'] = obj ? obj.value : undefined
        qualifications[index]['total'] = undefined
        qualifications[index]['score'] = undefined
        this.setState({qualifications})
    }

    reset = () => this.setState({qualifications: _.cloneDeep(this.props.qualifications)})
    save = () => {
        Actions.setQualifications(this.state.qualifications)
        this.props.toggle()
    }

    render() {
        var { modal, toggle, qualifications } = this.props
        var { qualifications, inputDegree, index } = this.state
        var selectedQua = index !== undefined ? qualifications[index] : undefined
        var scoreTypeSelected = selectedQua ? scoreType.filter((o) => selectedQua.scoreType === o.value)[0] : undefined
        var divisionTypeSelected = selectedQua ? divisionTypes.filter((o) => selectedQua.divisionType === o.value)[0] : undefined
        console.log(selectedQua, scoreTypeSelected, "scoreTypeSelected", scoreType[0], scoreType)
        return (
            <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">
                <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                    <div className="modal-header">Edit Qualifications</div>
                    <div className="v-align f-right" style={{ marginLeft: 'auto' }}>
                        <i className="fa fa-cog modal-close mg-r-15" ></i>
                        <i className="far fa-question-circle modal-close mg-r-15" ></i>
                        <i className="fas fa-times modal-close" onClick={toggle}></i>
                    </div>
                </div>
                <hr className="mg-r-0"></hr>
                <div className="modal-block">
                    <div className="modal-subheader">Degree</div>
                    <div className="row">
                        <div className="col-md-6">
                            <div><input type="text" className="form-control" value={inputDegree} onChange={(e) => this.setState({ inputDegree: e.target.value })}></input></div>
                        </div>
                        <div className="col-md-6">
                            <button className="btn btn-primary" onClick={this.addQualification}>
                                <i className="fas fa-plus mg-r-5"></i>Add Qualification
                                <span className="button-info">{qualifications.length}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <hr className="mg-0"></hr>
                <div className="row">
                    <div className="wd-pct-23 b-r-border pd-l-25 pd-t-15 pd-r-5">
                        <ul className="nav nav-left-tabs md-tabs tabs-left">
                            <div className="col-md-12">
                                <div className="row">
                                    {qualifications.map((qualification, i) => (
                                        <TabSwitch
                                            key={i}
                                            idx={i}
                                            title={qualification.degree}
                                            isActive={i === index}
                                            handleOnClick={this.setIndex}
                                        />
                                    ))}
                                </div>
                            </div>
                        </ul>
                    </div>
                    <div className="wd-pct-77 pd-t-15 pd-r-25 pd-l-15 pd-b-15">
                        <div className="mg-b-5">
                            <div className="modal-subheader">Field of Qualification
                                    <span className="mandatory-field">*</span>
                            </div>
                            <div><input type="text" className="form-control" value={selectedQua.field} onChange={(e) => this.setQualifications(e.target.value, "field")}></input></div>
                            <div className="modal-subheader">Institute</div>
                            <div><input type="text" className="form-control" value={selectedQua.institute} onChange={(e) => this.setQualifications(e.target.value, "institute")}></input></div>
                            <div className="checkbox-fade fade-in-primary mg-b-10">
                                <label>
                                    <input type="checkbox" checked={selectedQua.active} onChange={() => this.changeCurrentPosition(!selectedQua.active)}></input>
                                    <span className="cr">
                                        <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                                    </span>
                                    <span >Currently pursuing</span>
                                </label>
                            </div>
                            <div className="row mg-b-15">
                                <div className="col-md-6">
                                    <div className="modal-subheader">Start Month/Year</div>
                                    <DatePicker
                                        selected={selectedQua.startDate}
                                        onChange={(e) => this.setQualifications(e, "startDate")}
                                        customInput={<DateInput />}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="modal-subheader">End Month/Year</div>
                                    <DatePicker
                                        selected={selectedQua.active ? undefined: selectedQua.endDate}
                                        onChange={(e) => this.setQualifications(e, "endDate")}
                                        customInput={<DateInput disable={selectedQua.active}/>}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                </div>
                            </div>
                            <div className="row mg-b-15">
                                <div className="col-md-6">
                                    <div className="modal-subheader">City/State
                                        <span className="mandatory-field">*</span>
                                    </div>
                                    <div><input type="text" className="form-control" value={selectedQua.city} onChange={(e) => this.setQualifications(e.target.value, "city")}></input></div>
                                </div>
                                <div className="col-md-6">
                                    <div className="modal-subheader">Country
                                    <span className="mandatory-field">*</span>
                                    </div>
                                    <div><input type="text" className="form-control" value={selectedQua.country} onChange={(e) => this.setQualifications(e.target.value, "country")}></input></div>
                                </div>
                            </div>
                            <div className="row mg-b-15">
                                <div className="col-md-3">                                   
                                <div className="modal-subheader">Score Type</div>
                                    <SelectDD data={scoreType} onChange={(o) => this.onScoreTypeChange(o)} selected={scoreTypeSelected} isClearable={false} />
                                </div>
                                {scoreTypeSelected.value === 'CGPA' ? (<>
                                    <div className="col-md-3">   
                                        <div className="modal-subheader">Score</div>
                                        <div><input value={selectedQua.score} onChange={(e) => this.setQualifications(e.target.value, "score")} type="text" className="form-control"></input></div> 
                                    </div>
                                    <div className="col-md-3">   
                                        <div className="modal-subheader">Total</div>
                                        <div><input value={selectedQua.total} onChange={(e) => this.setQualifications(e.target.value, "total")} type="text" className="form-control"></input></div> 
                                    </div></>
                                ) : scoreTypeSelected.value === 'percentage' ? (<>
                                    <div className="col-md-3">   
                                        <div className="modal-subheader">Percentage</div>
                                        <div><input value={selectedQua.score} onChange={(e) => this.setQualifications(e.target.value, "score")} type="text" className="form-control"></input></div> 
                                    </div>
                                    <div className="col-md-3" /></>
                                ) : scoreTypeSelected.value === 'grade' ? (<>
                                    <div className="col-md-3">   
                                        <div className="modal-subheader">Grade</div>
                                        <div><input value={selectedQua.score} onChange={(e) => this.setQualifications(e.target.value, "score")} type="text" className="form-control"></input></div> 
                                    </div>
                                    <div className="col-md-3" />
                                    </>
                                ) : <><div className="col-md-6" /></>
                                }
                                <div className="col-md-3">
                                    <div className= "modal-subheader">Division</div>
                                    <div><SelectDD data={divisionTypes} onChange={(o) => this.setQualifications(o.value, "divisionType")} selected={divisionTypeSelected} isClearable={false} placeholder={"Select"} /></div>
                                </div>
                            </div> 

                            <div className="modal-subheader">Description</div>
                            <div><textarea className="textarea" value={selectedQua.description} onChange={(e) => this.setQualifications(e.target.value, "description")} style={{ marginTop: '0px', marginBottom: '0px', height: '153px' }}></textarea></div>
                        </div>
                    </div>
                </div>
                <hr className="mg-0 "></hr>
                <div className="pd-20 box-shadow-top">
                    <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>
                    <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                    <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>
                </div>
            </Modal>
        )
    }
}
export default EditMyExpModal;